import type {RepositoryVisibility} from '../components/repository-picker-types'

// Attempt to use the `org` parameter to filter the results if we have a `/` present in the query
// This is to be used with the `search` graphQL endpoint for type `Repository` only.
export function getRepositorySearchQuery(
  queryString: string,
  options?: {
    organization?: string
    excludeRepo?: string
    includeForks?: boolean
    repositoryVisibility?: RepositoryVisibility
  },
): string {
  const orgIndexSplit = queryString.indexOf('/')

  let query = 'in:name archived:false'
  if (options?.excludeRepo) {
    query = `${query} -repo:${options.excludeRepo}`
  }

  if (options?.includeForks) {
    query = `${query} fork:true`
  }

  if (options?.repositoryVisibility && options.repositoryVisibility !== 'PUBLIC') {
    // If the repository visibility is public, we don't need to add it to the query.
    // If it is either internal or private, we need to exclude the public repositories from the query.
    query = `${query} -visibility:public`
  }
  // if there is <owner>/<repo> in the query, use that to filter the results
  if (orgIndexSplit > 0 && queryString.split('/').length === 2) {
    // Naively extract the org name and repo name from the query by assuming anything before the / is the org name
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const orgSearchName = queryString.split('/')[0]!
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const repoSearchName = queryString.split('/')[1]!
    return `${query} org:${orgSearchName} ${repoSearchName}`
  }

  // If there is an org name, use that to filter the results
  if (options?.organization) {
    return `${query} org:${options.organization} ${queryString}`
  }

  // If there is no / in the query, or the org name is empty, just search for the repo name
  return `${query} ${queryString}`
}
